module.exports = __webpack_public_path__ + "static/media/beti-film-70.550add3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/beti-film-70.jpg
// module id = 161
// module chunks = 0